import FloatingActionButton from '@portalterreno/react-ui-core/FloatingActionButton';
import { useTranslation } from 'next-i18next';
import React from 'react';

import FloatingActionButtonDiv from './FloatingActionButtonDiv';
import StyledUpwardIconIcon from './StyledArrowUpwardIcon';
import StyledP from './StyledP';
import Wrapper from './Wrapper';

const goToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

const ButtonGoTop: React.FC = () => {
  const { t } = useTranslation('common');
  return (
    <Wrapper>
      <FloatingActionButtonDiv>
        <FloatingActionButton
          size='large'
          variant='circular'
          onClick={goToTop}
        >
          <StyledUpwardIconIcon />
        </FloatingActionButton>
        <StyledP>{t('goUp')}</StyledP>
      </FloatingActionButtonDiv>
    </Wrapper>
  );
};

export default ButtonGoTop;
